<div class="container-fluid class-loading">
    <div class="row justify-content-md-center mt-5">
        <img src="./assets/app/spinnerCoop.png" class="img-fluid img-splash mt-4" alt="">
    </div>
</div>

